/**
 * US ZIP code formatting + validation — the 5-digit or ZIP+4 (`12345-6789`) form USPS defines.
 * Shared by every address field across both portals that collects one (profile's mailing/secondary
 * address, payments' billing address, ...), so the accepted format and mask-as-you-type behavior
 * can't drift feature to feature.
 */

// USPS ZIP code assignment range — 00501 (Holtsville, NY) through 99950 (Ketchikan, AK) spans
// every assigned 5-digit ZIP.
const US_ZIP_MIN = 501;
const US_ZIP_MAX = 99950;

export const US_ZIP_REGEX = /^\d{5}(-\d{4})?$/;

/**
 * Mask a raw ZIP entry into "#####-####" as the user types. Without this, a member typing a
 * 9-digit ZIP+4 with no dash (e.g. pasted from a label) fails `US_ZIP_REGEX`, which requires the
 * dash literally — verified live.
 */
export function formatZip(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

/** Assumes the value has already passed `US_ZIP_REGEX` — checks the 5-digit prefix only. */
export function isValidUsZip(zip: string): boolean {
  const value = Number(zip.slice(0, 5));
  return value >= US_ZIP_MIN && value <= US_ZIP_MAX;
}
